import { hasProp } from 'vessel/utils'

const drawerItems = {}
const drawerIcons = {}

let drawerButtons = null
let drawerWrapper = null

function drawerItem(name, callback) {
  if (hasProp(name, drawerItems)) {
    return callback(drawerItems[name])
  }
}

function createDrawerButtons(vessel) {
  if (!drawerButtons) {
    const outerClasses = vessel.apply({
      position: 'fixed',
      marginRight: 'sm',
      pinBottom: true,
      pinRight: true
    })

    const innerClasses = vessel.apply({
      display: 'flex',
      flexDirection: 'col',
      flexItems: 'end'
    })

    drawerButtons = document.createElement('div')
    drawerButtons.classList.add(...Object.keys(outerClasses))

    drawerWrapper = document.createElement('div')
    drawerWrapper.classList.add(...Object.keys(innerClasses))

    drawerButtons.appendChild(drawerWrapper)
    document.body.appendChild(drawerButtons)
  }
}

function addDrawerButton({ $vessel, $drawer, name, button, buttonIcon, buttonText }) {
  if (button && !hasProp(name, drawerIcons)) {
    createDrawerButtons($vessel)

    const parseOption = (option, key, object) => {
      if (typeof(option) == 'string') {
        return { [key]: option }
      } else if (option == true) {
        return object
      } else {
        return option
      }
    }

    button     = parseOption(button, 'screen', { screen: null })
    buttonIcon = parseOption(buttonIcon, 'icon', { icon: 'ellipsis-h' })
    buttonText = parseOption(buttonText, 'text', { text: 'Open' })

    const { screen, ...buttonStyles } = button
    const btnDisplay = { all: 'flex' }

    if (screen) {
      btnDisplay[screen] = 'hidden'
    }

    const btnClasses = $vessel.apply({
      borderRadius: 'full',
      padding: 'xs',
      marginBottom: 'sm',
      cursor: 'pointer',
      backgroundColor: 'primary',
      color: 'white',
      flexItems: 'center',
      flexJustify: 'start',
      userSelect: 'none',
      shadow: true,
      display: btnDisplay,
      ...buttonStyles
    })

    const btn = document.createElement('div')
    btn.classList.add(...Object.keys(btnClasses))
    btn.addEventListener('click', () => $drawer.open(name))

    if (buttonIcon || !buttonText) {
      const { icon, ...iconStyles } = buttonIcon || { icon: 'ellipsis-h' }

      const boxClasses = $vessel.apply({
        width: 'sm',
        height: 'sm',
        display: 'flex',
        flexItems: 'center',
        flexJustify: 'center',
        ...iconStyles
      })

      const ico = document.createElement('i')
      ico.classList.add('el-icon-uil', 'uil', `uil-${icon}`)

      const box = document.createElement('span')
      box.classList.add(...Object.keys(boxClasses))

      box.appendChild(ico)
      btn.appendChild(box)
    }

    if (buttonText) {
      const { text, ...textStyles } = buttonText

      const txtClasses = $vessel.apply({
        marginRight: 'xs',
        ...textStyles
      })

      const txt = document.createElement('span')
      txt.classList.add(...Object.keys(txtClasses))

      txt.innerHTML = text
      btn.appendChild(txt)
    }

    drawerIcons[name] = btn
    drawerWrapper.appendChild(btn)
  }
}

function removeDrawerButton(name) {
  if (hasProp(name, drawerIcons)) {
    drawerIcons[name].remove()
    delete drawerIcons[name]
  }
}

export default (Vue) => {
  return Vue.observable({
    active: null,
    register(name, component) {
      drawerItems[name] = component
      addDrawerButton(component)
    },
    unregister(name) {
      drawerItems[name] = null
      removeDrawerButton(name)
    },
    toggle(name) {
      drawerItem(name, item => item.toggle())
    },
    open(name) {
      drawerItem(name, item => item.open())
    },
    close(name) {
      drawerItem(name, item => item.close())
    },
    isOpened(name) {
      return this.active == name
    },
    isClosed(name) {
      return !this.isOpened(name)
    },
    toggleButtons(hide) {
      if (drawerButtons) {
        if (hide) {
          drawerButtons.classList.add('hidden')
        } else {
          drawerButtons.classList.remove('hidden')
        }
      }
    }
  })
}
